import type { ShouldRevalidateFunction } from '@remix-run/react';

export const shouldRevalidateLoaderData: ShouldRevalidateFunction = ({
  nextUrl,
  currentUrl,
  defaultShouldRevalidate,
  formAction,
  formData,
}) => {
  const isCreatingLogin = formAction === '/create_login';

  const isRequestingMagicLink = formData?.get('request_magic_link') === 'true';

  if (isCreatingLogin && isRequestingMagicLink) {
    return false;
  }

  const currentModalParamValue = currentUrl.searchParams.get('modal');
  const nextModalParamValue = nextUrl.searchParams.get('modal');

  if (!isCreatingLogin && nextModalParamValue) {
    return false;
  }

  if (!isCreatingLogin && currentModalParamValue && !nextModalParamValue) {
    return false;
  }

  return defaultShouldRevalidate;
};
